module.exports = __webpack_public_path__ + "static/img/help.07012f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/match/help.png
// module id = 665
// module chunks = 2